import React from 'react';
import { useUserPreferences } from '../../../common/contexts/UserPreferencesContext';


const styles = {
    row: {
        display: 'flex',
        width: '80rem',
        flexDirection: 'row',
        marginLeft: 20,
        marginBottom: 20,
    },
    label: {
        width: '10rem',
        color: '#626262'
    },
    required: {
        width: '10rem',
        color: '#626262',
        fontSize: 10,
        fontStyle: 'italic'
    },
    input: {
        borderWidth: 1,
        borderColor: '#EBEBEB',
        borderStyle: 'solid',
        marginTop: 5,
        marginBottom: 5,
        padding: 10,
        borderRadius: 5,
        width: '60rem'
    }
}
const NewCrisisConfirmTab = ({ dashboardName, templateName, dashboardType, selectedContacts, moveToTab, dashboardTypeId, isEditMode,    currentScreenSize }) => {
    const { translations, language } = useUserPreferences();
    return (<div style={{ marginTop: 30 }}>
        {/* Dashboard Name*/}
        <div style={styles.row}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={styles.label}>{translations.name || "Name"}</span>
                <span style={styles.required}>{translations.required || "required"}</span>
            </div>
            <div style={{ width: '60rem', display: 'flex', flexDirection: 'row' }}>
                <label style={{ marginLeft: 10, marginRight: 20 }}>{dashboardName}</label>
            </div>
        </div>
        {/* Template Name*/}
        {!isEditMode && <div style={styles.row}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={styles.label}>{translations.template || "Template"}</span>
            </div>
            <div style={{ width: '60rem', display: 'flex', flexDirection: 'row' }}>
                <label style={{ marginLeft: 10, marginRight: 20 }}>{templateName}</label>
            </div>
        </div>}
        {/* Access/dashboard type */}
        <div style={styles.row}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={styles.label}>{translations.access || "Access"}</span>
                <span style={styles.required}>{translations.required || "required"}</span>
            </div>
            <div style={{ width: '60rem', display: 'flex', flexDirection: 'row' }}>
                <label style={{ marginLeft: 10, marginRight: 20 }}>{dashboardType}</label>
            </div>
        </div>
        {/* Selected Contacts */}
        {dashboardTypeId === 2 && <div style={styles.row}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={styles.label}>{translations.userswithaccess || "User with access"}</span>
            </div>
            <div style={{ width: '60rem', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                    <label style={{ marginLeft: 10, marginRight: 20 }}>{translations.tmpAddUser || 'Users'} ({selectedContacts?.length})</label>
                </div>
                <div style={{ maxHeight: '25rem', overflow: 'auto' }}>
                    {selectedContacts?.map(contact => <div style={styles.input}>
                        <label>{contact.name}</label>
                    </div>)}
                </div>
            </div>
        </div>}
    </div>);
}

export default NewCrisisConfirmTab